export { TranslatesService } from './translates.service';
export type { ILang } from './translates.interface';
